import { render, staticRenderFns } from "./EditCustomProduct.vue?vue&type=template&id=1a730797&"
import script from "./EditCustomProduct.vue?vue&type=script&lang=js&"
export * from "./EditCustomProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports